import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { Paragraph } = designSystem;

const AuthMethodDivider = ({ label = 'or' }) => (
  <div className="auth-method-divider">
    <Paragraph size="small" appearance="medium-emphasis">
      {label}
    </Paragraph>
  </div>
);

AuthMethodDivider.propTypes = {
  label: PropTypes.string,
};

export default AuthMethodDivider;
